$('.moreless-button').click(function(e) {
  e.preventDefault();
  $(this).prev('.health_partner-text').find('.health_partner-default_text').toggle();
  $(this).prev('.health_partner-text').find('.health_partner-more_text').toggle();
  if ($(this).text() == "Read more") {
    $(this).text("Read less")
  } else {
    $(this).text("Read more")
  }
});
$('.product-faq_item-title').click(function(){
 $(this).next('.product-faq_item-content').toggle();
 $(this).find('span').toggle();
});


$(document).ready(function () {
  var $video = $('#custom-video');
  var $button = $('#custom-play-btn');
  var videoEl = $video.get(0);

  $button.on('click', function () {
    if (videoEl.paused) {
      videoEl.play();
      $button.addClass('active'); // Change button text to "Pause"
    } else {
      videoEl.pause();
      $button.removeClass('active'); // Change back to "Play"
    }
  });

  $video.on('ended', function () {
    $button.removeClass('active'); // Reset to play when video ends
  });

  $('.real-feedback_items-list1').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    arrows: false,
    dots: false,
    draggable: true,
    responsive: [
      {
        breakpoint: 699,
        settings: {
          arrows: false,
          dots: false,
          slidesToShow: 1,
        }
      }
    ]
  });
  $("body").on("click", ".new-offer-copy_text", function () {
    var copy_text = $(this);
    var text = $(this).attr('code');
    var $temp = $("<input>");
      
    $("body").append($temp);
    $temp.val(text).select();
    document.execCommand("copy");
    $temp.remove();
    copy_text.text("Copied")
      
    setTimeout(function () {
      copy_text.text("Copy");
    }, 1000);
  });

  $('.custom-sticky-variant-picker-item').click(function(){
    var value = $(this).attr('data-value');
    $(`.variant-input[data-value="${value}"]`).find('label').trigger("click");
    $('.product-sticky .variant-input-wrap select').val(value).trigger('click');
    $('.custom-sticky-variant-picker-item').removeClass('is-selected');
    $(this).addClass('is-selected');
  });
});